import { render, staticRenderFns } from "./frmResetPassword.vue?vue&type=template&id=b2a6d84a&scoped=true"
import script from "./frmResetPassword.vue?vue&type=script&lang=js"
export * from "./frmResetPassword.vue?vue&type=script&lang=js"
import style0 from "./frmResetPassword.vue?vue&type=style&index=0&id=b2a6d84a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2a6d84a",
  null
  
)

export default component.exports